import { PropsWithChildren, ReactNode } from 'react'
import styled from '@emotion/styled'

import { Flex } from '../Flex'
import { Item } from '../Typography'

import { SubSidebarItem } from './SubSidebarItem'
import SubSideBarTitle from './SubSideBarTitle'

import { LogoutIcon } from '@/assets/icons'
import { colors } from '@/constants/colors'
import { useLogout } from '@/features/Auth/application/useLogout'
import { mediaQuery } from '@/utils/mediaQuery'

const SubSidebar = styled.div`
  width: 16.25rem;
  min-width: 16.25rem;
  border-right: 0.5px solid ${colors.darkBlue4};
  height: 100vh;
  left: 0;
  top: 0;
  position: sticky;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  ${mediaQuery('sm')} {
    display: none;
  }
`

export default function SubSideBar({
  children,
  title,
}: PropsWithChildren & { title?: ReactNode }) {
  const logout = useLogout()

  return (
    <SubSidebar>
      <SubSideBarTitle>{title}</SubSideBarTitle>
      <Flex
        flexDirection="column"
        justifyContent="space-between"
        flexGrow={1}
        mx="0.9375rem"
        my="1.25rem"
      >
        <Flex flexDirection="column">{children}</Flex>

        <SubSidebarItem
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              logout()
            }
          }}
          onClick={logout}
        >
          <LogoutIcon />
          <Item>Log out</Item>
        </SubSidebarItem>
      </Flex>
    </SubSidebar>
  )
}
